export const keys = ['days', 'note', 'tabs', 'weather-summary'];

export function shiftCells(columnSpan, newColumnSpan, Controller) {
  const shift = Math.abs(newColumnSpan - columnSpan);
  const functionsToApply = [];

  Controller.cells.forEach((cell, i, cells) => {
    /* We need to split the number into N parts because of
    a column might have 2 cells to expand (like the summary row) */
    let currentValue;
    if (shift % cells.length === 0) {
      currentValue = shift / cells.length;
    } else {
      const diff = cells.length - (shift % cells.length); // 1
      const div = Math.floor(shift / cells.length); // 2
      currentValue = i >= diff ? div + 1 : div;
    }

    if (newColumnSpan > columnSpan)
      functionsToApply[i] = colspan => colspan + currentValue;
    else if (newColumnSpan < columnSpan)
      functionsToApply[i] = colspan => colspan - currentValue;
    else functionsToApply[i] = colspan => colspan;
  });

  return function run() {
    Controller.cells.forEach((cell, i) => {
      const colspan = Number(cell.getAttribute('colspan'));
      const fn = functionsToApply[i];
      cell.setAttribute('colspan', fn ? fn(colspan) : colspan);
    });
  };
}

function lensColumnSpanPath(columnName, mode) {
  return [
    'tables',
    'basic' /* TODO: it should be dynamic property */,
    'content',
    columnName,
    'modes',
    mode,
    'colspan',
  ];
}

function ShiftPlugin($pool, $dataProxy) {
  function run(eventName, payload) {
    if (eventName !== 'Row:changeMode') return;
    if (!keys.includes(payload.Controller.name)) return;

    let mutate;
    $pool.push('Table:changeMode::idle', () => {
      const { Controller, columnName, mode, newMode } = payload;
      const columnSpan = $dataProxy.path(lensColumnSpanPath(columnName, mode));
      const newColumnSpan = $dataProxy.path(
        lensColumnSpanPath(columnName, newMode)
      );

      mutate = shiftCells(columnSpan, newColumnSpan, Controller);
    });

    $pool.push('Table:changeMode::mutate', () => {
      mutate();
    });
  }

  return run;
}

export default ShiftPlugin;
